import { AxiosError } from "axios";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import UserBasedTicketBasketRepository from "../repositories/UserBasedTicketBasketRepository/UserBasedTicketBasketRepository";
import {
  GetBasketHoldParamType,
  UserBasedTicketBasketHoldsSerializer,
} from "../types/basket";

// TODO: Replace with useModelService
function useHoldDetails(
  holdLink: string,
  params?: GetBasketHoldParamType,
  queryOptions?: UseQueryOptions<
    UserBasedTicketBasketHoldsSerializer,
    AxiosError
  >
): UseQueryResult<UserBasedTicketBasketHoldsSerializer, AxiosError> {
  const repo = new UserBasedTicketBasketRepository();
  return useQuery(
    ["holdDetails", holdLink],
    () => repo.holdDetails(holdLink, params),
    { ...queryOptions, refetchOnWindowFocus: false }
  );
}

export default useHoldDetails;
